import { render, staticRenderFns } from "./dui-char-count.vue?vue&type=template&id=a8c4febe&"
import script from "./dui-char-count.vue?vue&type=script&lang=js&"
export * from "./dui-char-count.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports